import { Dialog, DialogContent } from "@/core/components/ui/dialog";
import type { IEnrichedActivityFeedItem } from "@/activity-feed/activity-feed.d";
import { SPIFF_RULE_EVENTS } from "@/spiff-rules/constants";
import { ReviewAttributionContent } from "./review-attribution-content";
import { TGLAttributionContent } from "./tgl-attribution-content";

interface ActivityEventModalContentProps {
  activity: IEnrichedActivityFeedItem;
  onClose: () => void;
}

const ActivityEventModalContent = ({
  activity,
  onClose,
}: ActivityEventModalContentProps) => {
  switch (activity.spiff_event_name) {
    case SPIFF_RULE_EVENTS.five_star_review:
      return (
        <ReviewAttributionContent
          reviewId={activity.underlying_record_id}
          onClose={onClose}
        />
      );

    case SPIFF_RULE_EVENTS.tech_generated_lead:
      return <TGLAttributionContent onClose={onClose} activity={activity} />;
    default:
      return null;
  }
};

interface ActivityEventModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  activity: IEnrichedActivityFeedItem | null;
}

export const ActivityEventModal = ({
  open,
  onOpenChange,
  activity,
}: ActivityEventModalProps) => {
  const handleClose = () => {
    onOpenChange(false);
  };

  if (!activity) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent description="Manage activity event details">
        <ActivityEventModalContent activity={activity} onClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
};
